class ProductCarousel {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        if (!this.container) return;

        this.track = this.container.querySelector('[data-carousel-track]');
        this.prevBtn = this.container.querySelector('.carousel-nav-prev');
        this.nextBtn = this.container.querySelector('.carousel-nav-next');
        this.items = this.container.querySelectorAll('[data-carousel-item]');
        
        if (!this.track || !this.prevBtn || !this.nextBtn) return;

        this.init();
    }

    init() {
        this.setupCarousel();
        this.setupProductForms();
        this.setupEventListeners();
    }

    setupCarousel() {
        this.currentPosition = 0;
        this.itemWidth = this.items[0]?.offsetWidth || 250;
        this.gap = 20;
        this.itemTotalWidth = this.itemWidth + this.gap;
        this.trackWrapperWidth = this.container.querySelector('.carousel-track-wrapper').offsetWidth;
        this.visibleItems = Math.floor(this.trackWrapperWidth / this.itemTotalWidth);
        this.maxScroll = Math.max(0, (this.items.length - this.visibleItems) * this.itemTotalWidth);
        
        this.updateButtons();
    }

    setupProductForms() {
        // 表单提交处理
        this.container.querySelectorAll('[data-product-form]').forEach(form => {
            form.addEventListener('submit', this.handleFormSubmit.bind(this));
        });

        // 数量输入变化
        this.container.querySelectorAll('[data-product-id][class*="quantity-input"]').forEach(input => {
            input.addEventListener('change', this.handleQuantityChange.bind(this));
            input.addEventListener('input', this.handleQuantityChange.bind(this));
        });

        // 变体选择变化
        this.container.querySelectorAll('[data-product-id][class*="variant-select"]').forEach(select => {
            select.addEventListener('change', this.handleVariantChange.bind(this));
        });
    }

    setupEventListeners() {
        this.prevBtn.addEventListener('click', () => this.scroll('prev'));
        this.nextBtn.addEventListener('click', () => this.scroll('next'));
        
        // 窗口大小变化时重新计算
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.setupCarousel();
                this.updateCarousel();
            }, 250);
        });
    }

    scroll(direction) {
        const scrollAmount = this.itemTotalWidth;
        
        if (direction === 'prev') {
            this.currentPosition = Math.max(0, this.currentPosition - scrollAmount);
        } else {
            this.currentPosition = Math.min(this.maxScroll, this.currentPosition + scrollAmount);
        }
        
        this.updateCarousel();
        this.updateButtons();
    }

    updateCarousel() {
        this.track.style.transform = `translateX(-${this.currentPosition}px)`;
        this.track.style.transition = 'transform 0.3s ease';
    }

    updateButtons() {
        this.prevBtn.disabled = this.currentPosition <= 0;
        this.nextBtn.disabled = this.currentPosition >= this.maxScroll;
        
        this.prevBtn.setAttribute('aria-hidden', this.currentPosition <= 0);
        this.nextBtn.setAttribute('aria-hidden', this.currentPosition >= this.maxScroll);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        
        const form = e.target;
        const productId = form.dataset.productForm;
        const submitBtn = form.querySelector('.add-to-cart');
        const loadingText = submitBtn.querySelector('.btn-loading');
        const normalText = submitBtn.querySelector('.btn-text');
        
        // 获取最新数据
        const quantityInput = this.container.querySelector(`[data-product-id="${productId}"].quantity-input`);
        const variantSelect = this.container.querySelector(`[data-product-id="${productId}"].variant-select`);
        
        // 更新表单数据
        if (quantityInput) {
            const quantity = Math.max(1, Math.min(999, parseInt(quantityInput.value) || 1));
            form.querySelector('input[name="quantity"]').value = quantity;
        }
        
        if (variantSelect) {
            form.querySelector('input[name="id"]').value = variantSelect.value;
        }
        
        // 显示加载状态
        if (loadingText && normalText) {
            loadingText.hidden = false;
            normalText.hidden = true;
            submitBtn.disabled = true;
        }
        
        // 提交表单
        form.submit();
    }

    handleQuantityChange(e) {
        const input = e.target;
        const productId = input.dataset.productId;
        const form = this.container.querySelector(`[data-product-form="${productId}"]`);
        
        if (form) {
            // 确保数值在范围内
            const value = Math.max(1, Math.min(999, parseInt(input.value) || 1));
            input.value = value;
            form.querySelector('input[name="quantity"]').value = value;
        }
    }

    handleVariantChange(e) {
        const select = e.target;
        const productId = select.dataset.productId;
        const form = this.container.querySelector(`[data-product-form="${productId}"]`);
        
        if (form) {
            const selectedOption = select.options[select.selectedIndex];
            
            // 更新表单中的变体ID
            form.querySelector('input[name="id"]').value = select.value;
            
            // 可选：根据选择的变体更新价格显示
            const priceDisplay = form.closest('.product-card').querySelector('.price-current');
            if (priceDisplay && selectedOption.dataset.price) {
                priceDisplay.textContent = selectedOption.dataset.price;
            }
            
            // 更新按钮状态（如果变体不可用）
            const addToCartBtn = form.querySelector('.add-to-cart');
            if (addToCartBtn) {
                addToCartBtn.disabled = selectedOption.dataset.available === 'false';
                addToCartBtn.textContent = selectedOption.dataset.available === 'false' 
                    ? 'Sold Out' 
                    : 'Add to Cart';
            }
        }
    }
}

// 初始化轮播
document.addEventListener('DOMContentLoaded', () => {
    // 如果有多个轮播实例，可以这样初始化
    const carouselContainers = document.querySelectorAll('[data-carousel-container]');
    carouselContainers.forEach(container => {
        new ProductCarousel(container.id);
    });
});